import React from "react";
import { Link } from "react-router-dom";
import usePagination from "../../../hooks/usePagination";
import Pagination from "../../../components/Pagination/Pagination";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";

const AnnualReports = ({ data }) => {
  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(data, 10);
  const { getText } = useLanguageTranslation();

  useTableResponsive(data);

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
          <div className="title-sec">
            <h2>{getText("Annual Report", "वार्षिक रिपोर्ट")}</h2>
          </div>
          <div className="table-responsive">
            <table className="table table-striped custom-table">
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "56px" }}>
                    {getText("S.No.", "क्र. सं.")}
                  </th>
                  <th>{getText("Financial Year", "वित्तीय वर्ष")}</th>
                  <th>{getText("Download", "डाउनलोड")}</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index}>
                    <td data-key={getText("S.No.", "क्र. सं.")}>
                      {(currentPage - 1) * 10 + index + 1}
                    </td>
                    <td data-key={getText("Financial Year", "वित्तीय वर्ष")}>
                      {item.title}
                    </td>
                    <td data-key={getText("Download", "डाउनलोड")}>
                      {item.field_download ? (
                        <PdfZipItem
                          filePath={item?.field_download}
                          filesize={item?.filesize}
                        />
                      ) : (
                        <>
                          <Link
                            to={`/reports/${item.nid}`}
                            className="division-pdf-icon"
                          >
                            <span className="date">
                              {getText("View More", "अधिक देखें")}
                            </span>
                          </Link>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default AnnualReports;
